// 3XPRELAUNCH
function initProductsJS() {
  $(document).ready(() => {
    if (!$('html').hasClass('template-product') && !$('.quick-shop-content').length) return;
    
    $('[data-variant-input]').change()
  
    // issue with yotpo widgets loading a long time, especially on Safari
    yotpoInterval = setInterval(handleYotpoAfterLoad, yotpoIntervalTimeout)
  
    $('[data-product-gift-card-select]').change((e) => {
      const price = $('.product-gift-card-variants .selectize-input > div').data('cost')
      const strPrice = `$${price / 100}`
      $('.main-variant-select').change()
      $('.gift-card-product__price').text(strPrice)
    })
    $('.gift-card-with-product textarea').on('input', () => {
      $('.main-variant-select').change()
    })
  
    // NEWBY4
    const customBundleClasses = [
      'page-the_originals_-_set_of_6',
      'page-the_originals_-_set_of_4',
      'page-the_originals_-_set_of_3',
      'page-the_originals_-_set_of_9',
      'page-the_originals_-_set_of_8',
      'page-the_originals_-_set_of_12', 
      'page-build_your_3_tiles', 
      'page-the_original_tile_-_set_of_6', 
      'page-build_your_9_tiles', 
      'page-the_originals_-_set_of_12_tiles', 
      'page-the_flex_132_(medium)_-_set_of_7',
      'page-the_flex_132_(medium)_-_set_of_4',
      'page-the_flex_132_(medium)_-_set_of_8'
    ]

    const isCustomBundle = customBundleClasses.some(c => $('html').hasClass(c))
  
    const desktop = isDesktop();
    // add color override for Mac OS X
    if (navigator.platform === 'MacIntel') {
      $('.custom-product-gradient-block .gradient1').css('background-image', 'linear-gradient(to bottom, #CCAD8E 30%, #b07e69 100%)');
    }
  
    $('.color-options .variant-input').click(function(e) {
      if(e.target !== this || $(this).closest('.select-starter-color').length) return;
  
      const swatch = $(this).find('.color-swatch');
      swatch.click();
    })
  
    $('.js-qty__adjust').on('click', function() {
      const $el = $(this);
      const $qtySelector = $el.siblings('.js-qty__num');
      let qty = parseInt($qtySelector.val().replace(/\D/g, ''));
  
      qty = validateQty(qty);
  
      if ($el.hasClass('js-qty__adjust--plus')) {
        qty += 1;
        if (qty > 99) qty = 99;
      } else {
        qty -= 1;
        if (qty < 1) qty = 1;
      }
  
      $qtySelector.val(qty);
    });
  
    // add to cart
    $('.add-to-cart').click(function (e) {
      if ($('html').hasClass('page-corporate_gifts')) return;
  
      const selects = $(this).closest('.product-single__meta').find('select.selectized:not([data-type="color-option"], [data-type="gift-card-amount"])');
      selects.each(function(index) {
        if ($(this).val().trim() === '') {
          e.preventDefault();
          callInfoModal('please choose all your labels before adding to cart', 'shopping cart error');
          return false;
        } else if ($(this).val() === 'customize' && $($('input.custom-label')[index]).val().trim() === '') {
          e.preventDefault();
          callInfoModal('oops! you forgot your label', 'shopping cart error');
          return false;
        }
      });
    });
    $('.custom-label').on('input', function(e) {
      if (isCustomBundle) return;
  
      const val = e.target.value.trim() || $('select[data-type="label-value"]').find('option:selected').val()
      $('[data-selected-label]').html(`Label: ${val}`);
    })
    // add free capsule
    $('.custom-add-free-capsule').click(function (e) {
      $('.drawer__close-button.js-drawer-close').click();
    });
  
    if (!isCustomBundle) {
      const isAraki = $('.page-content')?.attr('data-product-handle')?.includes('araki')
      $('[data-join-waitlist]').click(function () {
        const input = $('.variant-input .active').parent().find('input');
        callPreOrderModal(
          input.data('product-name'),
          input.data('product-id'),
          input.data('variant-name'),
          input.data('variant-id'),
          isAraki ? 'araki-' : ''
        );
      })
    }
  
    function handleColorChange(el) {

      const $container = el.closest('.product-single__meta')
      const value = el.val();
      const index = el.data('color-index');
      const stock = el.data('variant-stock');
      const sku = el.data('variant-sku');

      //get product image
      const variant_image = el.data('variant-image')?.replace(/^\/\//, 'https://');
      // KLAVIYO TRACKING PRODUCT LATEST
      if (variant_image) {
        if (typeof item !== 'undefined') {
          item.ImageURL = variant_image;
          var _learnq = _learnq || []; 
          _learnq.push(['track', 'Viewed Product', item]);
          _learnq.push(['trackViewedItem', {
            Title: item.Name || '',
            ItemId: item.ProductID || '',
            Categories: item.Categories || [],
            ImageUrl: item.ImageURL || '',
            Url: item.URL || '',
            Metadata: {
              Brand: item.Brand || '',
              Price: item.Price || 0,
              CompareAtPrice: item.CompareAtPrice || 0
            }
          }]);
        }
        // console.log('tracking the new item!', item);
      }

      /* ===== BAS-PRESETBUILD - js logic ====== */
      let colorEnabled = true;
      //check if this container contains the disabled class
      if(el.hasClass('disabled')){
        //if it does, then we need to remove the disabled class
        $container.removeClass('disabled');
        colorEnabled = false;
      }
      const bas_preset_url = el.data('variant-bas-presetbuild-url');
      // console.log('bas_preset_url', bas_preset_url);
      //set the href of the link to the url
      if(colorEnabled){
        $('.bas-url-preset-link-container').show();
        $('.bas-url-preset-link').attr('href', bas_preset_url);
      }else{
        $('.bas-url-preset-link-container').hide();
      }
      /* ======================================= */

      // value text
      $('[data-selected-color]', $container).html(`The Capsule Color: ${value}`);;

      //if this page is featured products, the label text needs to be slightly different
      if($('html').hasClass('featured-products')){
        $('[data-selected-color]', $container).html(`The Capsule Color: ${value}`);
        // document.querySelector('input[name="size"][value="The Core"][data-index="option1"][id="size-select2"]').click();
      }

      if($('html').hasClass('new-parcelonly-pdps')){
        $('[data-selected-color]', $container).html(`The Parcel Color: ${value}`);
        // document.querySelector('input[name="size"][value="The Core"][data-index="option1"][id="size-select2"]').click();
      }

      // label img
      $('.product-label-image', $container).removeClass('active');
      // LABELPREVIEW-UPDATES
      $($(`.product-label-image.${value}`, $container)).addClass('active');
      // replaces this -->
      // $($('.product-label-image', $container)[index]).addClass('active');
      // console.log('name of color picked is ', value);

      // label text color
      // console.log('setting label color to ', labelColors[index]);
      // console.log('index is ', index);
      // console.log('full label colors are', labelColors);

      // color name is 

      
      
      $('.hex-graphics text', $container).css('fill', labelColors[index]);
      if (value == 'Merlot') {
        $('.hex-graphics text', $container).css('fill', 'white');
      }

      // product thumb
      $('.product__thumb-item', $container).removeClass('active');
      $($('.product__thumb-item', $container)[index]).addClass('active');
      $($('.product__thumb-item', $container)[index]).click();

      //customize badges per color and other warnings here
      // console.log("check color list", master_color_list);

      // santorini time
      //remove classes with badge+ anything
      $('.color-limited-edition, .image-preview-banner-badge').removeClass(function (index, className) {
        return (className.match (/(^|\s)badge-\S+/g) || []).join(' ');
      });
      //add the class with the badge now
      $('.color-limited-edition, .image-preview-banner-badge').addClass('badge-'+value);

      if (master_color_list[value]?.badge_text.length > 0) {
        $('.color-container').addClass('limited')
        
        $('.color-limited-edition').removeClass('pink-gradient')
        $('.color-limited-edition').addClass('terracotta-solid')

        // $('.color-limited-edition').text('Limited Edition')
        $('.color-limited-edition').text(master_color_list[value].badge_text)
        //color dropdown badge and message
        // $('.color-cart-warning').removeClass('hidden')
        // $('.color-limited-edition-message').text(' Orders that include the limited edition Neutral Capsules will ship by 12/12.')
        //badge on the image preview
        $('.image-preview-banner-badge:not(.static-badge)').removeClass('hidden')
        // $('.image-preview-banner-badge:not(.static-badge)').removeClass('terracotta-solid')
        $('.image-preview-banner-badge:not(.static-badge)').addClass('terracotta-solid')
        $('.image-preview-banner-badge:not(.static-badge)').text(master_color_list[value].badge_text)
      }else{
          $('.color-container').removeClass('limited')
          $('.color-cart-warning').addClass('hidden')
          $('.image-preview-banner-badge:not(.static-badge)').addClass('hidden')
          $('.image-preview-banner-badge:not(.static-badge)').text('')
      }

      //show the cart message, if relevant
      if (master_color_list[value]?.cart_warning.length > 0) {
        // console.log('master_color_list[value].cart_warning', master_color_list[value].cart_warning);
        $('.color-cart-warning').removeClass('hidden')
        $('.color-limited-edition-message').text(master_color_list[value].cart_warning)
      }else{
        $('.color-cart-warning').addClass('hidden')
        $('.color-limited-edition-message').text('')
      }


      //expected to ship colors, priority 1 (pink in this case)
      
      // if (metafields.airf.le_expected_to_ship_colors.includes(value)) {
      //   $('.color-container').addClass('limited')
        
      //   // $('.color-limited-edition').addClass('pink-gradient')
      //   // $('.color-limited-edition').removeClass('terracotta-solid')
      //   $('.color-limited-edition').removeClass('pink-gradient')
      //   $('.color-limited-edition').addClass('terracotta-solid')

      //   $('.color-limited-edition').text('Limited Edition')

      //   //color dropdown badge and message
      //   // $('.color-cart-warning').removeClass('hidden')
      //   // $('.color-limited-edition-message').text(' Orders that include the limited edition Neutral Capsules will ship by 12/12.')
        
      //   //badge on the image preview
      //   $('.image-preview-banner-badge').removeClass('hidden')
      //   // $('.image-preview-banner-badge').removeClass('terracotta-solid')
      //   $('.image-preview-banner-badge').addClass('terracotta-solid')
      //   $('.image-preview-banner-badge').text('Limited Edition')

      // //limited availability colors
      // }else if (limitedAvailabilityColors.includes(value)) {

      //   $('.color-container').addClass('limited')
        
      //   // $('.color-limited-edition').addClass('pink-gradient')
      //   // $('.color-limited-edition').removeClass('terracotta-solid')
      //   $('.color-limited-edition').removeClass('pink-gradient')
      //   $('.color-limited-edition').addClass('terracotta-solid')

      //   $('.color-limited-edition').text('Limited Edition')

      //   //color dropdown badge and message
      //   // $('.color-cart-warning').removeClass('hidden')
      //   // $('.color-limited-edition-message').text(' Orders that include the limited edition Neutral Capsules will ship by 12/12.')
        
      //   //badge on the image preview
      //   $('.image-preview-banner-badge').removeClass('hidden')
      //   // $('.image-preview-banner-badge').removeClass('terracotta-solid')
      //   $('.image-preview-banner-badge').addClass('terracotta-solid')
      //   $('.image-preview-banner-badge').text('Limited Edition')

      //   //get the remaining amounts of stock ready to go
      //   // let amount_left = stock_sku_availability[sku] ? stock_sku_availability[sku] : (base_color_availability[value] ? base_color_availability[value] : 0);
      //   // // debugger;
      //   // if(amount_left){
      //   //   const stockAbs = Math.abs(amount_left);
      //   //   //do some jiu jitsu to get the amount left
      //   //   if(stockAbs > 1000){
      //   //     amount_left = Math.round(stockAbs / 100);
      //   //   }else if(stockAbs > 100){
      //   //     amount_left = Math.round(stockAbs / 10);
      //   //   }else{
      //   //     amount_left = stockAbs;
      //   //   }

      //   //   $('.color-limited-edition-message').text(' Limited availability, only '+amount_left+' left.');
      //   // }else{
      //   //   $('.color-limited-edition-message').text(' Limited edition colors, only a few left.');
      //   // }
        
      //   //get the absolute value of the stock
      //   // $('.color-limited-edition-message').text(' Limited availability, only '+stockAbs+' left. ');

      //   //badge on the image preview
      //   // $('.image-preview-banner-badge').addClass('hidden')
      //   // $('.image-preview-banner-badge').text('')

      //   // $('.image-preview-banner-badge').removeClass('hidden')
        
      //   // $('.image-preview-banner-badge').text('Limited Edition')
       
      // } else {
      //   $('.color-container').removeClass('limited')
      //   $('.color-cart-warning').addClass('hidden')
      //   $('.image-preview-banner-badge').addClass('hidden')
      //   $('.image-preview-banner-badge').text('')
      // }
          
      const labelSelectize = $('.label-block').find('.premade-labels [data-build-selectize]').eq(0)
      const label = $('.label-block').find('.premade-labels .item').attr('data-value') || ''
      if (window.outOfStockAraki[value] && 
        label.length > 0 && 
        window.outOfStockAraki[value].includes(label)
      ) {
        const selectize = labelSelectize.data('selectize');
        $('.label-block').data('prev-value', '')
        callPreOrderModal(
          labelSelectize.data('product-name'),
          labelSelectize.data('product-id'),
          labelSelectize.data('variant-name'),
          labelSelectize.data('variant-id'),
          'araki-'
        );
        selectize.clear()
        selectize.setValue("");
      }
  
      if (window.updateLabels) window.updateLabels();
    }
    // the product known as days of the week (now pillcase)
    // HANDLING SIZE OR TYPE CHANGES
    $('.page-pillcase [data-product-select]').change(() => {
      const index = $('[data-product-select] option:selected').index() + 1
      $('[data-variant-image]').addClass('invisible');
      $(`[data-variant-image=${index}]`).removeClass('invisible');
      сheckEmptyBlock()
    })

    
    //same as above but for the page that explicitly contains holiday-products but does not contain media-v2
    $('.holiday-products:not(.media-v2) [data-product-select]').change(() => {
      console.log('V1 STRATEGY BASED OFF INDEX');
      const index = $('[data-product-select] option:selected').index() + 1
      $('[data-variant-image]').addClass('invisible');
      $(`[data-variant-image=${index}]`).removeClass('invisible');
      сheckEmptyBlock()
    })

    // CHARCOALFINALSALE
    $('.charcoal-sets [data-product-select]').change(() => {
      // console.log('size changes in charcoal page!');
      const index = $('[data-product-select] option:selected').index() + 1
      $('[data-variant-image]').addClass('invisible');
      $(`[data-variant-image=${index}]`).removeClass('invisible');
      сheckEmptyBlock();

      // badge bs
      $('.image-preview-banner-badge').text('Final sale');
      $('.image-preview-banner-badge').show();
      $('.image-preview-banner-badge').addClass('terracotta-solid');
      $('.image-preview-banner-badge').removeClass('hidden');
    })

    $('.page-the_capsules_in_harbor [data-product-select]').change(function () {
      console.log('capsules in harbor product selector changed');

      const variantTitle = $(this).find('option:selected').text().toLowerCase();
      const hideLabel = variantTitle.includes('extender') || variantTitle.includes('extender');

      if (hideLabel) {
        $('.expand-wrapper[data-property="label"]').hide();
      } else {
        $('.expand-wrapper[data-property="label"]').show();
      }
    })


    // color change detector Parcel
    $('input[type="radio"].variant__input-7041799520341').on('change', function() {
      var colorName = $(this).data('color-name');
      var productId = $(this).data('product-id');
      
      // console.log("Color seleccionado: " + colorName);
      // console.log("ID de producto: " + productId);

      var inputId = $(this).attr('id');
      if (colorName === 'Berry') {
        
        $('label.size-select-item.single img').attr('src', 'https://cdn.shopify.com/s/files/1/0247/7326/3445/files/ROUGE_PARCEL_01_BUTTON_S.png?v=1731431750');
        $('label.size-select-item.duo img').attr('src', 'https://cdn.shopify.com/s/files/1/0247/7326/3445/files/ROUGE_PARCEL_02_BUTTON_s.png?v=1731431752');
        $('label.size-select-item.trio img').attr('src', 'https://cdn.shopify.com/s/files/1/0247/7326/3445/files/ROUGE_PARCEL_03_BUTTON_S.png?v=1731431754');
      }
      
      if (colorName === 'Pebble') {
        
        $('label.size-select-item.single img').attr('src', 'https://cdn.shopify.com/s/files/1/0247/7326/3445/files/baggu-single.png?v=1729379501');
        $('label.size-select-item.duo img').attr('src', 'https://cdn.shopify.com/s/files/1/0247/7326/3445/files/baggu-duo.png?v=1729379501');
        $('label.size-select-item.trio img').attr('src', 'https://cdn.shopify.com/s/files/1/0247/7326/3445/files/baggu-trio.png?v=1729379501');
      }
    });


    $('.page-the_vault_capsules [data-product-select]').change(() => {

      const variantTitle = $('[data-product-select] option:selected').text()
      if(variantTitle.toLowerCase().includes('extender')){ 
        console.log('extender picked');
        // hide the label container
        // class=expand-wrapper, data-property=label
        $('.expand-wrapper[data-property="label"]').hide();
      }else{
        console.log('extender not picked!!');
        // show the label container
        $('.expand-wrapper[data-property="label"]').show();
      }

      
      
    });

    $('.page-the_vault_capsules input[name="Color"]').click(function(e) {

      //we want now to disable the sizes that are unavailable when a color gets changed, so they cant click on it
      console.log('vault color changed, now proceed to disable sizes that are not available');

      //lookup and go through all the variants that have this color option
      const selectedColor = $(this).val();
      console.log('selectedColor', selectedColor);
      //first go through all the variants in data product select and check the options and echo them out
      const availableSizes = [];
      $('[data-product-select] option').each(function() {
        const optionText = $(this).text();
        //if the optionText contains the selectedColor, then we want to get the size from it
        // NOW THIS OPTIONS DATA-COLOR and data-size contain the information we need
        // for any of the options if they match the color they picked, print out the sizes that are available and the ones that
        // are not. if there is a match it means that it is disabled and we must disable the Extender or the Small or what
        // ever button here. start by enabling all of them 
        if($(this).data('variant-color') === selectedColor) {
          const size = $(this).data('variant-size');
          console.log('size available for this color', size);
        }

        // if(optionText.includes(selectedColor)){
        //   //split by - and get the second part
        //   const size = optionText.split('-')[1].trim();
        //   availableSizes.push(size);
        // }
      });
    

    });



    $('.featured-products [data-product-select]').change(() => {
      
      const index = $('[data-product-select] option:selected').index() + 1
      // console.log('picked index', index);
      $('[data-variant-image]').addClass('invisible');
      $(`[data-variant-image=${index}]`).removeClass('invisible');

      //get some data from the selected variant
      const variantTitle = $('[data-product-select] option:selected').text()
      //if the variant title contains "Core", set the capsule list to be ABC, else if the variant title contains "Full", set the list to be XYZ

      if(variantTitle.includes('Starter')){ 
          $('.list-of-labels-string').text('Blank, Sun Icon, Pill Icon');
          $('.product-prelabeled-tags').attr('style', 'display:none');
          $('#featured_choose_product').text('Choose Product:');
          $('.product-single__description-visible').html(`
              <p>Over 2 million leakproof, magnetic, customizable travel containers sold, and counting. Choose between our three fan favorite bundles.</p>
              <br/>
              <p>The Starter set includes:</p>
              <ul>
                  <li>Labels: Blank, Sun Icon, Pill Icon</li>
                  <li>Sizes: 1 Small, 2 Medium, 1 Extender</li>
              </ul>
          `);
      } else if(variantTitle.includes('Core')){
          $('.list-of-labels-string').text('Blank, Body Wash, Sun Icon, Pill Icon, Moisturizer, Cleanser, Shampoo, Conditioner');
          $('.product-prelabeled-tags').attr('style', 'display:none');
          $('#featured_choose_product').html('Choose Product: <h1 class="choose-product-badge"> 15% off </h1>');
          $('.product-single__description-visible').html(`
              <p>Over 2 million leakproof, magnetic, customizable travel containers sold, and counting. Choose between our three fan favorite bundles.</p>
              <br/>
              <p>The Core set includes:</p>
              <ul>
                  <li>Labels: Blank, Body Wash, Sun Icon, Pill Icon, Moisturizer, Cleanser, Shampoo, Conditioner</li>
                  <li>Sizes: 3 Smalls, 2 Mediums, 1 Large, 2 Extra Label Tiles</li>
              </ul>
          `);
      } else if(variantTitle.includes('Full')){
          $('.list-of-labels-string').text('Blank, Body Wash, Sun Icon, Pill Icon, Moisturizer, Cleanser, Shampoo, Conditioner, Serum, Blank, Lotion');
          $('.product-prelabeled-tags').attr('style', 'display:none');
          $('#featured_choose_product').html('Choose Product:<h1 class="choose-product-badge"> 15% off </h1>');
          $('.product-single__description-visible').html(`
              <p>Over 2 million leakproof, magnetic, customizable travel containers sold, and counting. Choose between our three fan favorite bundles.</p>
              <br/>
              <p>The Full Routine set includes:</p>
              <ul>
                  <li>Labels: Blank, Body Wash, Sun Icon, Pill Icon, Moisturizer, Cleanser, Shampoo, Conditioner, Serum, Blank, Lotion</li>
                  <li>Sizes: 4 Small, 3 Medium, 2 Large, 2 Extra Label Tiles</li>
              </ul>
          `);
      }
      
      
      //get the capsules list from the variant
      
      сheckEmptyBlock();

      // badge bs
      // $('.image-preview-banner-badge').text('Final sale');
      // $('.image-preview-banner-badge').show();
      // $('.image-preview-banner-badge').addClass('terracotta-solid');
      // $('.image-preview-banner-badge').removeClass('hidden');
    })

    // SPATULA TYPE CHANGES
    // ADAPT THIS FOR THE PARCEL
    $('.page-the_parcel:not(.media-v2) [data-product-select]').change(() => {
      // console.log('change to data-product-select PARCEL PAGE ONLY');
      const index = $('[data-product-select] option:selected').index() + 1
      $('[data-variant-image]').addClass('invisible');
      $(`[data-variant-image=${index}]`).removeClass('invisible');
      сheckEmptyBlock()
      // get the variant title 
      const variantTitle = $('[data-product-select] option:selected').text()
      const title = variantTitle.split('-')[0].trim()
      $('.option-name .expand-value').text(title)
      $('.pre-order-variant-name').text('the spatula');
      $('.pre-order-product-name').html('spatula');


      // debugger;
      //spatula_waitlist
      var spatula_waitlist = true;
      if (spatula_waitlist) {
        // $('.quantity-controls').addClass('hidden');
        // $('[data-join-waitlist]').removeClass('hidden');
      } else {
        // $('.quantity-controls').removeClass('hidden');
        // $('[data-join-waitlist]').addClass('hidden');
      }
    })

    $('.page-the_starter_set [data-product-select]').change(() => {
      console.log('VARIANT SELECTOR FOR LABELS');
      const variantLabels = $('[data-product-select] option:selected').data('variant-labels');
      if(variantLabels){
        updatePDPLabels(variantLabels);
      }
    });

    // MAESTER VARIANT SELECTOR CHANGE DETECTOR
    // this will only work on pages with media-v2 tag or class
    // if a page does not have media-v2, it will not work

    $('.media-v2 [data-product-select]').change(() => {
      console.log('MEDIA V2 STRATEGY BASED OFF MEDIA-ID');

      var special_case = false;
      //if this page contains the class .dynamic-parcel, return
      if($('html').hasClass('dynamic-parcel')){
        special_case = false;
        // console.log('dynamic-parcel page detected, applying special case logik');
        // return;
      }

      // console.log('product changed');

      const media_id = $('[data-product-select] option:selected').data('media-id');
      const variantsku = $('[data-product-select] option:selected').data('variant-sku');
      const variantID = $('[data-product-select] option:selected').val(); 
      
      console.log('media_id', media_id);
      console.log('variantsku', variantsku);
      console.log('variantID', variantID);
      
      //handle variant images a little bit differently here, this is how it works in media-v2 world
      if(!special_case){
        $(`[data-media-id=${media_id}]`).removeClass('invisible');
        
        const variantImages = $('[data-variant-image], [data-additional-img-variant-id], [data-additional-image-by-color-name]');
        // handle additional images by color name, color specific logick
        variantImages.addClass('invisible');
        $(`[data-media-id=${media_id}]`).removeClass('invisible');
        $(`[data-additional-img-variant-id=${variantID}]`).removeClass('invisible');
      }else{
        const variantImages = $('[data-additional-img-variant-id], [data-additional-image-by-color-name]');
        // handle additional images by color name, color specific logick
        variantImages.addClass('invisible');
      }
      
      $(`[data-additional-img-variant-id=${variantID}]`).removeClass('invisible');


      // now we're going to reveal the images that are specific to each color, not just the variant ids
      const colorName = $('[data-variant-input][data-color-swatch]:checked').data('variant-name');
      // console.log('colorName', colorName);

      $(`[data-additional-image-by-color-name=${colorName}]`).removeClass('invisible');

    })

    //todo- project2025 full discovery and discovery parcel and color changes handling

   // PROJECT2025 dynamic parcel changes
    // 3XPARCEL
    $('.dynamic-parcel input[name="sizing"], .dynamic-parcel input[name="size"], .dynamic-parcel input[name^="properties[_color_parcel_"').change(() => {
      //scroll to the first image of the carousel, or click the first thumbnail 

      const index = 1

      $('[data-variant-image]').addClass('invisible');
      $(`[data-variant-image=${index}]`).removeClass('invisible');
      const selectedParcelColors = [];

      //check if this parcel is a small, medium, large, or extra large from the size selector

      //get the input name sizing selected
      var currentSizing = $('input[name="sizing"]:checked').val() ?? '';
      var hideCanvasColor = false;

      //set the sizing here
      $('.custom-parcels-property-string-sizing').val(currentSizing);

      if(currentSizing.toLowerCase() == 'small'){
        currentSizing = 'small';
        hideCanvasColor = true;
      }else if(currentSizing.toLowerCase() == 'large'){
        currentSizing = 'large';
        hideCanvasColor = true;
      }else if(currentSizing.toLowerCase() == 'extra large'){
        currentSizing = 'xlarge';
        hideCanvasColor = true;
      }else if(currentSizing.toLowerCase() == 'medium'){
        currentSizing = '';
        hideCanvasColor = false;
      }

     

      //if we're supposed to hide the canvas color, unselect any actively selected canvas color parcels (just default to the Pebble one)
      //hide all the canvas selections. else, show the Canvas color, prevent this function from being called for now until this process is done

      if(hideCanvasColor){
        //unselect the canvas color
        $('input[name^="properties[_color_parcel_"]').each(function() {
          if($(this).val() === 'Canvas'){
            // only uncheck it if it is checked
            $(this).attr('disabled', true);
            $(this).parent().addClass('disabled');
            $(this).parent().removeClass('active');
            $(this).parent().hide();

            if($(this).is(':checked')){
              $(this).prop('checked', false);
              //this is triggering the change event so we need to prevent that from happening if possible
              var radioGroup = $(this).attr('name');
              $('input[name="' + radioGroup + '"][value="Pebble"]').prop('checked', true);
            }
          }
        });
      }else{
        //show all the canvas selectors
        $('input[name^="properties[_color_parcel_"]').each(function() {
          if($(this).val() === 'Canvas'){
            $(this).attr('disabled', false);
            $(this).parent().removeClass('disabled');
            $(this).parent().addClass('active');
            $(this).parent().show();
          }
        });
      }

      var hasCanvasColor = false;
      // console.log('currentSizing', currentSizing);
      //we will add the currentSizing to the productCode
      $('input[name^="properties[_color_parcel_"]').each(function() {
        //now if this is checked, add it to the selected colors
        if($(this).is(':checked')){
          selectedParcelColors.push($(this).val());
        }
        if($(this).is(':checked') && !($(this).is(':disabled')) && $(this).val() === 'Canvas'){
          hasCanvasColor = true;
        }
      });


      var image_size = 850;
      // console.log('All selected colors:', selectedParcelColors);

      if(hasCanvasColor){
        image_size = 1200;
      }

      var dynamicImageSRC = `https://dynacapsule.com/bundles.php?product=parcel${currentSizing}&color_parcel=${selectedParcelColors.join(',')}&size=${image_size}`;

      //check the title of the selection if its single, duo or trio
      const variantTitle = $('[data-product-select] option:selected').text()
      const title = variantTitle.split('-')[0].trim()
      // console.log('title', title);

      $('.color-parcel-radio-option').hide();
      $('.color-parcel-radio-option.option-1').show();
      $('.color-parcel-radio-option.option-2 input').attr('disabled', true);
      $('.color-parcel-radio-option.option-3 input').attr('disabled', true);

      $('.custom-parcels-property-string').val(selectedParcelColors.slice(0, 1).join(','));

      //if the variant title contains duo, set the image to be the duo image
      if(title.includes('Duo')){
        dynamicImageSRC = `https://dynacapsule.com/bundles.php?product=parcelduo${currentSizing}&color_parcel=${selectedParcelColors.join(',')}&size=${image_size}`;
        $('.color-parcel-radio-option.option-2').show();
        $('.color-parcel-radio-option.option-2 input').attr('disabled', false);
        //join only the first two from selectedparcelColors into
        $('.custom-parcels-property-string').val(selectedParcelColors.slice(0, 2).join(', '));
      }
      if(title.includes('Trio')){
        dynamicImageSRC = `https://dynacapsule.com/bundles.php?product=parceltrio${currentSizing}&color_parcel=${selectedParcelColors.join(',')}&size=${image_size}`;
        $('.color-parcel-radio-option.option-2').show();
        $('.color-parcel-radio-option.option-2 input').attr('disabled', false);
        $('.color-parcel-radio-option.option-3').show();
        $('.color-parcel-radio-option.option-3 input').attr('disabled', false);
        //join only the first two from selectedparcelColors into
        $('.custom-parcels-property-string').val(selectedParcelColors.slice(0, 3).join(', '));
      }

      // now update the field so we can track this image across the site and email
      $('.custom-image-url-labeled').val(dynamicImageSRC);

      const $imageContainer = $('[data-variant-image=1] .product-image-main .image-wrap');
      const $currentImage = $imageContainer.find('.main-gallery-img');
      
      console.log('loading image', dynamicImageSRC);
      
      // Add loading state
      $imageContainer.addClass('is-loading');
      $imageContainer.css('opacity', '0.3');
    
      // Create and append loader if it doesn't exist
      // if (!$imageContainer.find('.loader').length) {
      //   $imageContainer.append('<div class="loader">Loading...</div>');
      // }
    
      // Remove any existing load handlers before adding new one
      $currentImage.off('load');
      
      // Add the new load handler
      $currentImage.on('load', function() {
        $imageContainer.removeClass('is-loading');
        $imageContainer.find('.loader').remove();
        // console.log('image loaded', dynamicImageSRC);
        $(this).css('opacity', '1');
        $imageContainer.css('opacity', '1');
      });
    
      // Set the new image source
      $currentImage
        .attr('src', dynamicImageSRC)
        .attr('data-src', dynamicImageSRC)
        .attr('data-srcset', dynamicImageSRC)
        .attr('srcset', dynamicImageSRC);
    
      // Update the tracking field
      $('.custom-image-url-labeled').val(dynamicImageSRC);

      // SPECIALPARCELPRICING this means this will work even if the parcel does not support special pricing!! amirite!!!
      //UPDATE PRICING OF PARCELS HERE, IF WE ARE USING SPECIAL PARCELS, FOR NOW IT IS JUST CANVAS
      var active_special_parcel_count = 0;
      $('input[name^="properties[_color_parcel_"]').each(function() {
        //check if this option is enabled or disabled, or if it has the property disabled=disabled
        if($(this).is(':checked') && !($(this).is(':disabled')) && $(this).val() === 'Canvas'){
          active_special_parcel_count++;
        }
      });
      //update the option for the number of parcels canvas
      // console.log('active_special_parcel_count', active_special_parcel_count);
      $(".special.main-variant-select").val(active_special_parcel_count).change();

    })

    $('input[name^="properties[_color_parcel_"').change(() => {
      window.mainGallerySwiper.slideTo(0);
      updateActiveThumb(0);
      //go through each of the properties with the color parcel and based on the index
      //change set the name of color-parcel-selected-{index} to the value of the selected color

      $('input[name^="properties[_color_parcel_"').each(function() {
        //data is in data-color-parcel-index="{{ parcel_index }}"
        if($(this).is(':checked')){
          const index = $(this).data('color-parcel-index');
          const color = $(this).val();
          $(`.color-parcel-selected-${index}`).text(color);
        }
      });
    })

    // from now on the evolved products will skip this logic
    $('.dynamic-sets .color-options .variant-input,.dynamic-sets input[name^="properties[_color_parcel_"').change(() => {

      console.log('handling dynamic sets here');

      const firstImageIndex = 3
      $('[data-variant-image]').addClass('invisible');
      $(`[data-variant-image]:first`).removeClass('invisible');

      $(`[data-main-photos-swiper-thumbs] [data-variant-image]:first`).removeClass('invisible');


      const selectedParcelColors = [];
      $('input[name^="properties[_color_parcel_"]').each(function() {
        if($(this).is(':checked')){
          selectedParcelColors.push($(this).val().toLowerCase());
        }
      });

      // console.log('All selected colors:', selectedParcelColors);
      var productCode = 'discovery';

      //get the name of the selected color of the capsules (not the parcel) now
      // it is in the input[name="Color"]
      const capsuleColor = $('input[name="Color"]:checked').val().toLowerCase();

      //get the sku of the selected product
      const variantsku = $('[data-product-select] option:selected').data('variant-sku');
      if(variantsku?.includes('fulldisc')){
        productCode = 'fulldiscovery';
      }

      if(variantsku?.includes('fullroutine')){
        productCode = 'fullroutine';
      }

      var dynamicImageSRC = `https://dynacapsule.com/bundles.php?product=${productCode}&color=${capsuleColor}&color_parcel=${selectedParcelColors.join(',')}&size=1200`;

      console.log('dynamicImageSRC', dynamicImageSRC);
    
      //update the source of the first image
      $(`[data-variant-image]:first .product-image-main .image-wrap .main-gallery-img, [data-main-photos-swiper-thumbs] [data-variant-image]:first .product-image-main .image-wrap .main-gallery-img`)
        .attr('src', dynamicImageSRC)
        .attr('data-src', dynamicImageSRC)
        .attr('data-srcset', dynamicImageSRC)
        .attr('srcset', dynamicImageSRC);

      // now update the field so we can track this image across the site and email
      $('.custom-image-url-labeled').val(dynamicImageSRC);

      //check the value of the special main variant select
      var current_special_parcel_count = $(".special.main-variant-select").val() ?? 0;
      // console.log('current_special_parcel_count', current_special_parcel_count);

      //now update the number of special parcel count here, in case we have to
      var active_special_parcel_count = 0;
      $('input[name^="properties[_color_parcel_"]').each(function() {
        //check if this option is enabled or disabled, or if it has the property disabled=disabled
        // console.log('checking special parcels!');
        if($(this).is(':checked') && !($(this).is(':disabled')) && $(this).val() === 'Canvas'){
          active_special_parcel_count++;
        }
      });

      // console.log('active_special_parcel_count', active_special_parcel_count);
      //update the option for the number of parcels canvas only if the number is different
      if(current_special_parcel_count !== active_special_parcel_count){
        // console.log('updating special parcel count');
        $(".special.main-variant-select").val(active_special_parcel_count).change();
      }else{
        // console.log('no need to update special parcel count');
      }

    })

    // HANDLING COLOR CHANGES
    $('input[name="Color"], input[name="Color"] + label').click(function(e) {
      const variantInput = $(this).parent();
      const input = variantInput.find('input');
      // turning on the waitist button on and off
      
      // if (input.hasClass('disabled')) {
      //   $('.quantity-controls').addClass('hidden');
      //   $('[data-join-waitlist]').removeClass('hidden');
      // } else {
      //   $('.quantity-controls').removeClass('hidden');
      //   $('[data-join-waitlist]').addClass('hidden');
      // }
      const idx = $(input).data('color-index') + 1;
      // setActiveVideo(idx)

      const variantImages = $('[data-variant-image]');
      // console.log('we should ignore the changes if its a pillcase like page');
      if(variantImages.length === 0 
        || $('html').hasClass('page-pillcase')
        || $('html').hasClass('featured-products')
      ) return;
      
      
      // if this page contains the class media v2, return
      if($('html').hasClass('media-v2')){
        // console.log('media-v2 page detected, returning');
        return;
      }
      variantImages.addClass('invisible');
      $(`[data-variant-image=${idx}]`).removeClass('invisible');
      сheckEmptyBlock()
      
    });

    function updateSizesImages(color) {

      // This flow is to update featured products images Featured Started / Core / Full
      const variantsku = $('[data-product-select] option:selected').data('variant-sku');
       
      var is_featured = false;
      if (variantsku?.includes('Featured')) {
        if(variantsku.includes('Starter') || variantsku.includes('Core') || variantsku.includes('Full')){
          is_featured = true;
        }

      }
      if (is_featured) {
        $('.size-select-sizes label img').each((i, el) => {
          var sizeName = $(el).parent().text().trim().toLowerCase()

          const sizeBySizeName = {
            'the starter': 'starter',
            'the core': 'core',
            'the full routine': 'fullroutine'
             }
          
          const $image = $(el).parent().find('img')
          var colorname = variantsku.split('-').pop();

          //find skus to change images
          var filtered_sku = $('[data-product-select] option').filter(function() {
            var sku = $(this).data('variant-sku');
            return sku && 
                   sku.toLowerCase().includes(sizeBySizeName[sizeName].toLowerCase()) && 
                   sku.toLowerCase().includes(colorname.toLowerCase());
            });
          // apply changes
          if (filtered_sku.length) {
            var imagenThumbnail = filtered_sku.data('variant-image-thumbnail');
            $image.attr('src',imagenThumbnail);
            } else {
                console.log('Sku does not match for image thumbnail');
            }

        })
      }

      $('.size-select-sizes label img').each((i, el) => {
        var sizeName = $(el).parent().text().trim().toLowerCase()
        const size = sizeBySizeName[sizeName]
        const $image = $(el).parent().find('img')
        const colorIndex = bundleColorValues.indexOf(color) + 1
        // console.log("size: "+size+" color: "+colorIndex)
        if (typeof size !== 'undefined' && size !== null) {
          $image.attr('src', `https://dynacapsule.com/singles.php?is_single=true&capsules=${colorIndex}&size=${size}&cropped=true`)
        }
        
        // $image.attr('src', `https://dynacapsule-529bc86c6a21.herokuapp.com/singles.php?is_single=true&capsules=${colorIndex}&size=${size}&cropped=true&source=productsjs`)

      })
    }
  

     // Función para actualizar los contenedores de etiquetas
     function updatePDPLabels(labelsText) {
      try {
        const text = typeof labelsText === 'string' ? labelsText : (labelsText ? String(labelsText) : '');
        if ($ && $('.list-of-labels-string').length) {
          $('.list-of-labels-string').text(text);
        }
        if (!text) return;

        const tagsContainer = document.getElementById("product-prelabels-image-tags-container");
        const commaSeparatedLabels = document.querySelector(".comma-separated-style .list-of-labels-string");
        const labels = text.split(',').map(function (l) { return l.trim(); }).filter(Boolean);
        const iconMap = typeof productTagsIconUrls !== 'undefined' && productTagsIconUrls ? productTagsIconUrls : {};

        if (tagsContainer) {
          tagsContainer.innerHTML = '';
          labels.forEach(function (label) {
            const labelUpper = label.toUpperCase();
            const labelDiv = document.createElement("div");
            labelDiv.className = "product-prelabels-image-tags-label";
            if (iconMap[labelUpper]) {
              const iconImg = document.createElement("img");
              iconImg.src = iconMap[labelUpper];
              iconImg.alt = label + ' icon';
              iconImg.className = "product-prelabels-image-tags-icon";
              labelDiv.appendChild(iconImg);
            } else {
              labelDiv.textContent = label;
            }
            tagsContainer.appendChild(labelDiv);
          });
        }

        if (commaSeparatedLabels) {
          commaSeparatedLabels.textContent = labels.join(', ');
        }
      } catch (e) {
        console.warn('updatePDPLabels:', e);
      }
    }

    function setActiveVideo (idx) {
      console.log('setActiveVideo', idx);
      const variantVideos = $('[data-variant-video]');
      const currentVideoWrapper = $(`[data-variant-video=${idx}]`)
      if(variantVideos.length === 0 || currentVideoWrapper.length === 0) return;
  
      const previousVideoWrapper = $(`.active[data-variant-video]`)
      if (previousVideoWrapper.index() === idx - 1) return
  
      variantVideos.removeClass('active');
      currentVideoWrapper.addClass('active');
      const currentVideo = currentVideoWrapper.find('video')
      if (!currentVideo.length) return
  
      if(!currentVideoWrapper.hasClass('loaded')) {
        const videoSource = currentVideo.attr('data-video-src')
        const poster = currentVideo.attr('data-poster')
        currentVideo.attr('poster', poster);
        currentVideo.html(`<source src="${videoSource}" type="video/mp4"></source>` );
        currentVideo[0].load()
        currentVideoWrapper.addClass('loaded')
      } else {
        currentVideo[0].play()
      }
      if (previousVideoWrapper.length) {
        const prevVideo = previousVideoWrapper.find('video')[0]
        //to prevent previous video from twitching on variant change
        setTimeout(() => {
          prevVideo.pause();
          prevVideo.currentTime = 0;
        }, 1000)
      }
    }
  
    // color picker: predefined bundles, predefined tile bundles, the-capsule, the-tile
    $('input[name="Color"]').change(function() {
      updateSizesImages($(this).data('color-name'))
      colorsVariantPreviewChange($(this).val().toLowerCase(), $('label.color-swatch'));
      handleColorChange($(this));
      // showExpectedToShipWarning($(this))
      $('.expand-wrapper[data-property="label"]').removeClass('disabled');
      /*
      // Update CTA for pre-order Araki products
      if ($('html').hasClass('page-cadence_capsules_x_araki_koman') || $('html').hasClass('page-cadence_tiles_x_araki_koman')) {
        let button = $('button.add-to-cart p span:first-child')
        let buttonText = button.text().split('-')
        buttonText[0] = "Pre-order "
        button.text(buttonText.join('-'))
        $('.product-artist_icons_text').show()
      }
      */
    });

    // $('input[name="size"]').change(function() {
    //   console.log('handle size change');
    // });

    var isFeaturedProduct = $('html').hasClass('featured-products');
  
    if (!isCustomBundle && !isFeaturedProduct) {
      $('.color-options .variant-input:first-of-type').click()
    }
  
    $('[data-description-trigger]').click(function(e) {
      e.preventDefault();
      e.stopPropagation();
      const altText = $(e.target).data('alt-text')
      $(e.target).data('alt-text', $(e.target).text())
      $(e.target).text(altText)
      $(e.target).closest('.product-single__description-wrapper').find('.product-single__description-hidden').toggleClass('expanded');
    });
    initMainGallery()
  
    $('[data-modal-gallery-trigger]').click(function(e) {
      e.preventDefault();
      e.stopPropagation();
      $('.product__modal-gallery').toggleClass('active')
      $('body').toggleClass('modal-open');
    });
  
    if($('[data-modal-gallery-swiper]').length > 0) initModalGallerySlider();
  
    //NEW RESIZE EVENT LOGIC TO PREVENT IOS RESIZE LOOP!!
    let previousWindowWidth = $(window).width();
    $(window).on('resize', function() {
      const currentWindowWidth = $(window).width();
      if (currentWindowWidth !== previousWindowWidth) {
        // console.log('resizing window horizontal');
        initMainGallery();
        previousWindowWidth = currentWindowWidth;
      }else{
        // console.log('resizing window vertical, do nothing');
      }
    });
    
    // $(window).on('resize', initMainGallery)
  
    $(document).on('click', '.product-single__toggle-content', function(e) {
      console.log('preventing toggle content')
      e.preventDefault();
      const container = $('.product-single__description')
      const wrapper = $('.product-single__description-wrapper')
  
      const isOpen = wrapper.hasClass('expanded')
      wrapper.toggleClass('expanded')
    });

    function hideColorsBySKU() {
      
      // NEWBY4
      const $item = $('.product-section [data-cpsl_cnt]')
      const bundles = [
      'build-your-6',
      'the-132-set-of-4',
      'the-132-set-of-4-sm',
      'the-132-set-of-3-sm',
      'the-132-set-of-5',
      'the-132-set-of-8',
      'the-132-set-of-7-2',
      'the-132-set-of-7',
      'build-your-12',
      'build-your-6-special-edition',
      'build-your-6-fp',
      'build-your-12-fp',
      'the-132-set-of-7-fp',
      'the-132-set-of-7-parcel',
      'the-132-set-of-6',
      'build-your-3',
      'build-your-9',
      'build-your-4',
      'build-your-5',
      'build-your-8'
    ]

      $('.variant-input-wrap .color-options .variant-input').show().each((i, el) => {
        if (bundles.includes($item.attr('data-product-handle'))) return

        const color = $(el).find('input').val()
        const size = $('.size-select-sizes input:checked').val()
        const variant = $($('.product-single__variants option').toArray().find((el) => $(el).text().includes(color) && (size ? $(el).text().includes(size) : true)))
        const sku = variant.data('variant-sku')
        const capsuleCount = Number($item.attr('data-cpsl_cnt'))
        const tilesCount = Number($item.attr('data-tile_cnt'))
        const count = tilesCount || capsuleCount
        const presetSizes = $item.attr('data-sizes').split(',')
        const presetColors = $item.attr('data-preset-colors').split(',')
        if (!count || count <= 1) return $(el).toggle(!product_skip_colors_by_sku.includes(sku))
      
        $('.product-single__meta .cart-expected-to-ship').hide()
        for (var i = 1; i <= count; i++) {
          const curPresetColor = presetColors.length && presetColors[0] ? presetColors[i - 1] : false
          const shadowcolor = curPresetColor || color
          const optionSize = size && sizeBySizeName[size.toLowerCase()]
          const shadowSize = optionSize || (presetSizes[i - 1] ? presetSizes[i - 1].toLowerCase() : defaulf_size.toLowerCase())
          const shadowSKU = getShadowProduct(capsuleCount ? 'capsule' : 'tile', shadowcolor, shadowSize)?.sku
          if (product_skip_colors_by_sku.includes(shadowSKU)) {
            $(el).hide()
          }
        }
      })
      const selectedColor = $('.variant-input-wrap .color-options input:checked')
      if (!selectedColor.is(":visible")) {
        $('.variant-input-wrap .color-options input:visible').click()
      }
    }
    hideColorsBySKU()
    $('.product-single__meta .size-select-sizes input').change(hideColorsBySKU)
  });
  moveSectionsToFaq()
}

function сheckEmptyBlock() {
  $('.swiper-slide-visible').each((i, block) => {
    const $block = $(block);
    const allChildrenInvisible = $block.children().toArray().every(child => {
      return $(child).hasClass('invisible')
    });
    $block.show();
    if (allChildrenInvisible) {
      $block.hide();
    } 
  });
}

function moveSectionsToFaq() {
  const $calculator = $('#capsule-calculator-BaS').closest('.shopify-section')
  const $table = $('.bas-table').closest('.shopify-section')
  $('.faq-section-capsule-calculator-BaS').append($calculator)
  $('.faq-section-build-a-system-table').append($table)
}

function handleYotpoAfterLoad() {
  // console.log('handleYotpoAfterLoad called');
  
  if (!window.yotpo) return;
  if(!$('#yotpo-reviews .main-widget').length) return;

  clearInterval(yotpoInterval);

  const bottomLineWidget = $(Yotpo.widgets.bottomline.selector)
  const reviewLink = bottomLineWidget.find('.yotpo-bottomline').find('a')
  let firstLinkText = '';

  bottomLineWidget.find('.yotpo-bottomline a').each(function(index, element) {
    if (index === 0) {
      firstLinkText = $(element).text();
      return false; // This breaks the loop after the first iteration
    }
  });
  
  const mainWidget = $(Yotpo.widgets.main.selector)
  const mainInner = mainWidget.find('.yotpo-bottomline')
  const totalReviewsText = mainInner.find('.reviews-qa-labels-container span:first-child').text()
  const averageRating = mainInner.find('.avg-score').text()
  const ratingNumber = averageRating.split(' ')[0]
  const totalReviewsNumber = totalReviewsText.split(" ")[0]
  // console.log('totalReviewsNumber', totalReviewsNumber);
  if(totalReviewsNumber < 5) return $('.yotpo-bottomline').hide()
  const stars = $('.yotpo-stars').eq(0).clone()
  reviewLink.text(`${averageRating} (${firstLinkText})`)
  reviewLink.attr('style', 'display: block !important; text-decoration: underline !important; margin-left: 6px !important; line-height: 21px !important;pointer-events: none !important;');
  mainInner.find('.bottom-line-items').hide().after('<h1 class="customTitle">What customers are saying...</h1>')
  mainInner.append(`<div class="customTotalReviews"><p class="customRatingNumber">${totalReviewsNumber}</p><p class="customRatingText">total reviews</p></div>`)
  mainInner.append(`<div class="customAvgRating"><p class="customRatingNumber">${ratingNumber}</p><p class="customRatingText">average rating</p></div>`)
  $('.customAvgRating .customRatingNumber').append(stars)

  //remove all the .custom-section-shop-all a.text-m elements from the page, just outright delete them now that you've updated these
  $('.custom-section-shop-all a.text-m').remove();
}

function processDescription() {
  const container = $('.product-single__description')
  const wrapper = $('.product-single__description-wrapper')
  const height = container[0].offsetHeight
  const scrollHeight = container[0].scrollHeight

  if (height >= scrollHeight) return

  wrapper.append('<a class="product-single__toggle-content"><span class="default-text">Show more</span><span class="expanded-text">Show less</span><span class="ico-chevron-down"></span></a>')
}

function initMainGallery() {
  initMobileMainGallery()
  initMainGalleryDots()
}

// ODDIT SWIPER THUMBS FOR DESKTOP
function initMobileMainGallery() {
  const isDesktopView = isDesktop();

  // Destroy existing swipers if they exist
  if (window.mainGallerySwiper && !window.mainGallerySwiper.destroyed) {
    window.mainGallerySwiper.destroy();
    window.mainGallerySwiperThumbs.destroy();
  }

  // Main gallery swiper
  window.mainGallerySwiper = new Swiper("[data-main-photos-swiper]", {
    autoHeight: false,
    observer: true,
    observeParents: true,
    spaceBetween: 8,
    direction: 'horizontal',
    slidesPerView: isDesktopView ? 'auto' : 1.1,
    centeredSlides: isDesktopView,
    // pagination: isDesktopView ? false : {
    //   el: ".swiper-pagination",
    //   clickable: true
    // },
    navigation: {
      nextEl: ".swiper-button-next-new",
      prevEl: ".swiper-button-prev-new",
    },
    mousewheel: !isDesktopView,
    on: {
      slideChange: function () {
        if (window.mainGallerySwiperThumbs) {
          window.mainGallerySwiperThumbs.slideTo(this.activeIndex);
          updateActiveThumb(this.activeIndex);
          preloadVideos(this.activeIndex);
          // console.log('slide changed to -- we', this.activeIndex);
          //activate video here for that slide

          // '.swiper-slide.swiper-slide-active :not(.invisible) video'

          // const video = document.querySelector('.swiper-slide.swiper-slide-next :not(.invisible).media-wrapper video');
          // if (video) {
          //   console.log('exxxecute video nowss');
          //   // Force preload
          //   video.preload = 'auto';
          //   video.autoplay = 'true';
          //   video.load();
          //   // video.play();
          //   // Force preload
          //   // Play
            
          // }else{
          //   console.log('no video found in this here slide');
          // }

        }
      }
    }
  });

  // Thumbs swiper
  window.mainGallerySwiperThumbs = new Swiper("[data-main-photos-swiper-thumbs]", {
    spaceBetween: 10,
    slidesPerView: 4,
    threshold: 5,
    freeMode: true,
    watchSlidesProgress: true,
    direction: isDesktopView ? 'vertical' : 'horizontal',
    on: {
      click: function() {
        window.mainGallerySwiper.slideTo(this.clickedIndex);
        preloadVideos(this.clickedIndex);
        updateActiveThumb(this.clickedIndex);
      }
    }
  });

  // Initial active thumb highlight
  updateActiveThumb(0);
}

function updateActiveThumb(activeIndex) {
  const thumbs = document.querySelectorAll('[data-main-photos-swiper-thumbs] .swiper-slide');
  thumbs.forEach((thumb, index) => {
    thumb.classList.toggle('swiper-slide-thumb-active', index === activeIndex);
  });
}

function preloadVideos(activeIndexToActivate) {
  // Get current active slide index
  const activeSlide = document.querySelector('.swiper-slide-active');
  const allSlides = Array.from(document.querySelectorAll('.swiper-slide'));
  const activeIndex = activeIndexToActivate;

  
  // Preload current + next 2-3 videos
  for (let i = 0; i < 3; i++) {
    const slideIndex = activeIndex + i;
  
    if (slideIndex < allSlides.length) {
      const video = allSlides[slideIndex].querySelector(':not(.invisible).media-wrapper video:not(.inactive)');

      if (video && video.preload !== 'auto') {
        video.preload = 'auto';
        video.autoplay = true;
        video.muted = true;
        video.load();
      }
    }
  }
}

function initModalGallerySlider() {
  new Swiper ('[data-modal-gallery-swiper]', {
    centeredSlides: true,
    slidesPerView: 1,
    //autoHeight: true,
    mousewheel: {
      forceToAxis: true,
      invert: true,
    },
    keyboard: true,
    //freeMode: true,
    //threshold: 1,
    spaceBetween: 8,
    breakpoints: {
      769: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        centeredSlides: false,
      },
    },
    scrollbar: {
      el: ".swiper-scrollbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
}

function colorsVariantPreviewChange(name, labels) {
  labels.each(function() {
    const item = $(this);

    if (item.hasClass(`color-swatch--${name}`)) {
      item.parent().addClass('active');
      item.addClass('active');
    } else {
      item.parent().removeClass('active');
      item.removeClass('active');
    }
  });
}

function validateQty(qty) {
  if (parseFloat(qty) !== parseInt(qty) || isNaN(qty)) return 1;
  return qty;
}


// animation for capsule page
function typingAnimation(block, index = 0, duration = 4500) {
  if (typingAnimating) return;
  typingAnimating = true;
  const newIndex = index + 1 === typingWords.length ? 0 : index + 1;
  if (!block.hasClass('animating')) block.addClass('animating');

  // multiline logic
  if (newIndex === 1) {
    const block2 = block.clone();
    block2.removeClass('animating');
    block2.html('&nbsp;');
    block2.appendTo(block.parent());
    block.html('toothpaste');
    block.parent().addClass('animating-multiline');
    block.addClass('animating-v2');

    setTimeout(() => {
      block.removeClass('animating');
      block.removeClass('animating-v2');
      block2.html('tablets');
      block2.addClass('animating');
      block2.addClass('animating-v2');

      setTimeout(() => {
        typingAnimating = false;
        block.parent().removeClass('animating-multiline');
        block2.remove();
        typingAnimation(block, newIndex);
      }, duration / 2);
    }, duration / 2);
  } else {
    block.html(typingWords[newIndex]);

    setTimeout(() => {
      typingAnimating = false;
      block.removeClass('animating');
      typingAnimation(block, newIndex);
    }, duration);
  }
}

// gift card textarea

$('textarea#gift-message').on('change keyup paste', function(e) {
  const { value } = e.target;
  const { length } = value;
  $('#gift-message-characters > span').html(length);

  // Update card preview
  const selector = $('.product-image-main .image-wrap p[data-location="message"] span[data-gift-card-message]');
  selector.text(value);
});

$('input#gift-recipient').on('change keyup paste', function(e) {
  const { value } = e.target;

  // Update card preview
  const selector = $('.product-image-main .image-wrap p[data-location="greeting"] span[data-gift-card-recipient]');
  selector.text(value);
});

$('input#gift-sender').on('change keyup paste', function(e) {
  const { value } = e.target;

  // Update card preview
  const selector = $('.product-image-main .image-wrap p[data-location="greeting"] span[data-gift-card-sender]');
  selector.text(value);
});

function callPreOrderModal(productName, productId, variantName, variantId, modalPrefix = '') {
  $(`#${modalPrefix}pre-order-modal`).data({ productId, variantId })
  $('.pre-order-product-name').html(productName);
  $('.pre-order-variant-name').html(variantName);
  $(`.js-modal-open-${modalPrefix}pre-order-modal`).click();
}

$('#pre-order-modal .btn-subscribe').click(function () {
  const modal = $('#pre-order-modal');

  const productId = modal.data('productId');
  const variantId = modal.data('variantId');
  var product_variant_name = $('.pre-order-variant-name').text();

  const data = {
    // '$email': modal.find('[type=email]').val(),
    a: 'KQCdPN',
    email: modal.find('[type=email]').val(),
    product_name: product_variant_name,
    variant: variantId,
    product: productId,
    platform: 'shopify',
    subscribe_for_newsletter: modal.find('#subscribe-newsletter').is(":checked")
  };

  // new way of tracking email
  console.log('firing email'); 
  if (window._learnq) {
    _learnq.push(['identify', {
      '$email': data.email
    }]);

    _learnq.push(['track', 'Waitlist Signup', data]);
  }
})

function initMainGalleryDots() {
  const galleryContainer = $('.product__photos')
  const paginationContainer = galleryContainer.find('.swiper-pagination')

  if(!isDesktop()) {
    paginationContainer.css('top', '');
    paginationContainer.css('left', '');

    return
  }

  const header = $('header')
  const slides = galleryContainer.find('.swiper-slide')
  if(slides.length === 0) return;

  const $firstSlide = $(slides[0])
  const paginationTop = header.outerHeight() + $firstSlide.outerHeight()/2;
  paginationContainer.css('top', paginationTop);
  paginationContainer.css('left', $firstSlide.offset().left + PDP_MEDIA_NAVIGATION_LEFT_OFFSET);

  if(!paginationContainer.children().length) {
    const dots = [...Array(slides.length)].map(
      (_, index) => `<div class="swiper-pagination-bullet"></div>`
    ).join('')
    paginationContainer.append(dots)
  }

  paginationContainer.children().first().addClass('active')
}

function showExpectedToShipWarning($color) {
  const $item = $('.product-section [data-cpsl_cnt]')
  // NEWBY4
  const bundles = [
  'build-your-6',
  'the-132-set-of-7-2',
  'the-132-set-of-7',
  'the-132-set-of-2',
  'the-132-set-of-3',
  'the-132-set-of-4',
  'the-132-set-of-4-sm',
  'the-132-set-of-3-sm',
  'the-132-set-of-5',
  'the-132-set-of-8',
  'the-132-set-of-9',
  'build-your-12',
  'build-your-6-special-edition',
  'build-your-6-fp',
  'build-your-12-fp',
  'the-132-set-of-7-fp',
  'the-132-set-of-7-parcel',
  'the-132-set-of-6',
  'build-your-3',
  'build-your-9',
  'build-your-4',
  'build-your-5',
  'build-your-8'
]


  if (!bundles.includes($item.attr('data-product-handle'))) {
    const color = $color.data('variant-name')
    
    const variant = $($('.product-single__variants option').toArray().find((el) => $(el).text().includes(color)))
    const sku = variant.data('variant-sku')
    
    // console.log('check stock for sku', sku);
    // let amount_left = stock_sku_availability[sku];

    const capsuleCount = Number($item.attr('data-cpsl_cnt'))
    const tilesCount = Number($item.attr('data-tile_cnt'))
    const count = tilesCount || capsuleCount
    
  
    const presetSizes = $item.attr('data-sizes').split(',')
    const presetColors = $item.attr('data-preset-colors').split(',')
  
    if (!count || count <= 1) return $('.product-single__meta .cart-expected-to-ship').toggle(!!metafields.airf.expected_to_ship_sku.includes(sku))
  
    $('.product-single__meta .cart-expected-to-ship').hide()
    for (var i = 1; i <= count; i++) {
      const curPresetColor = presetColors.length && presetColors[0] ? presetColors[i - 1] : false
      const shadowcolor = curPresetColor || color
      const shadowSize = presetSizes[i - 1] ? presetSizes[i - 1].toLowerCase() : defaulf_size.toLowerCase()
      const shadowSKU = getShadowProduct(capsuleCount ? 'capsule' : 'tile', shadowcolor, shadowSize)?.sku
  
      if (metafields.airf.expected_to_ship_sku.includes(shadowSKU)) {
        $('.product-single__meta .cart-expected-to-ship').show()
      }
    }
  }

  $('.image-preview-banner-badge').hide()
  $('.cart-expected-to-ship-bundles').hide()
  $('.cart-limited-edition-bundles').hide()

  const selectedColors = $('.color-dropdown .item').map(function() {
    return $(this).attr('data-value');
  }).get();
  
  let chosen_le_colors_array = [];
  selectedColors.map((color) => {
    //if the color is a limited edition color and its not in the array
    if(limitedAvailabilityColors.includes(color) && !chosen_le_colors_array.includes(color)){
      chosen_le_colors_array.push(color);
    }
  })
  const chosen_le_colors = chosen_le_colors_array.join(', ');

  selectedColors.map((color) => {
    
    //products that are expected to ship in the future
    if (metafields.airf.le_expected_to_ship_colors.includes(color)) {
      $('.cart-expected-to-ship-bundles').show()
    }
    
    // LIMITEDTOO
    //limited edition colors specifically
    if(limitedAvailabilityColors.includes(color)){
      $('.image-preview-banner-badge').addClass('terracotta-solid')
      $('.image-preview-banner-badge').text('Limited Edition')
      $('.image-preview-banner-badge').show()

      // if(chosen_le_colors.length > 0){
      //   $('.cart-limited-edition-bundles').show()
      //   $('.cart-limited-edition-bundles').text('Orders that include the limited edition Neutral Capsules will ship by 12/12.');
      // }
    }

  })
}
